import { ExchangeBoxResultDTO } from 'src/app/shared/interfaces/exchange/exchange-dto.interface';

export class ExchangeMailList {
  mailId: string;
  dateMail: string;
  expediteur: string;
  expediteurEmail: string;
  subject: string;
  exchangeMailChargeId: number;
  exchangeMailCharge: {
    id: number;
    mailIdentifier: string;
    contactId: number;
    datePriseEnMain: string;
  };
  date: string;
  dateDocument: string;
  id: string;
  typeExchange: boolean;
  typeEntrantSortant: string;

  constructor(data: ExchangeBoxResultDTO, typeEntrantSortant?: string) {
    Object.assign(this, data);
    this.date = this.dateMail;
    this.dateDocument = this.dateMail;
    this.id = this.mailId;
    this.typeExchange = true;
    if (typeEntrantSortant) {
      this.typeEntrantSortant = typeEntrantSortant;
    }
  }
}
